/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersOrderIdCancelMutationRequest, PostOrdersOrderIdCancelMutationResponse, PostOrdersOrderIdCancelPathParams, PostOrdersOrderIdCancel400 } from "../entities/PostOrdersOrderIdCancel";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postOrdersOrderIdCancel } from "../api/postOrdersOrderIdCancel";
import { useMutation } from "@tanstack/react-query";

export const postOrdersOrderIdCancelMutationKey = () => [{ url: '/orders/:order_id/cancel' }] as const

export type PostOrdersOrderIdCancelMutationKey = ReturnType<typeof postOrdersOrderIdCancelMutationKey>

/**
 * @description Отмена заказа
 * @summary Отмена заказа
 * {@link /orders/:order_id/cancel}
 */
export function usePostOrdersOrderIdCancel<TContext>(options: 
{
  mutation?: UseMutationOptions<PostOrdersOrderIdCancelMutationResponse, ResponseErrorConfig<PostOrdersOrderIdCancel400>, {order_id: PostOrdersOrderIdCancelPathParams["order_id"], data: PostOrdersOrderIdCancelMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostOrdersOrderIdCancelMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postOrdersOrderIdCancelMutationKey()

  return useMutation<PostOrdersOrderIdCancelMutationResponse, ResponseErrorConfig<PostOrdersOrderIdCancel400>, {order_id: PostOrdersOrderIdCancelPathParams["order_id"], data: PostOrdersOrderIdCancelMutationRequest}, TContext>({
    mutationFn: async({ order_id, data }) => {
      return postOrdersOrderIdCancel(order_id, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}